import React, { 
  useState, 
  useEffect, 
  useContext, 
  useRef, 
} from 'react';
import { 
  Col, 
  Container, 
  Row, 
  Form, 
} from 'react-bootstrap';
import Pagination from 'react-bootstrap/Pagination';
import { Button, ButtonGroup } from '@/shared/components/Button';
import toast from 'react-hot-toast';
import { FaExclamationCircle } from 'react-icons/fa';
import { useHistory } from 'react-router-dom';
import ProgressBar from '../../Loader';
import MealCard from './MealCard';
import { Mealcontext } from '../../../../context/MealContext';
import { BookingContext } from '../../../../context/BookingContext';
import { GlobalContext } from '../../../../context/GlobalContext';
import { SideBarRefreshContext } from '../../../../context/SideBarRefreshContext';
import { AuthContext } from '../../../../context/AuthContext';


const Search = () => {
  const { refresh, setRefresh } = useContext(Mealcontext);
  const { tripDataFlag, setTripDataFlag } = useContext(BookingContext);
  const [searchQuery, setSearchQuery] = useState(''); 
  const [mealsdata, setMealsData] = useState([]);
  const [filteredMealsData, setFilteredMealsData] = useState([]);
  const { apiGlobal } = useContext(GlobalContext);
  const [isLoading, setIsLoading] = useState(true);
  const { sideBarRefresh } = useContext(SideBarRefreshContext);
  const { countryId } = useContext(AuthContext);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 7;

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination Logic - Slice data for the current page
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredMealsData.slice(indexOfFirstItem, indexOfLastItem);

  // Total pages
  const totalPages = Math.ceil(filteredMealsData.length / itemsPerPage);

  // Generate a range of pagination items, including "..."
  const pageNumbers = [];
  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  for (let i = startPage; i <= endPage; i += 1) {
    pageNumbers.push(i);
  }

  if (startPage > 1) pageNumbers.unshift('...');
  if (endPage < totalPages) pageNumbers.push('...');

  const history = useHistory();

  const isMounted = useRef(true);
  const CACHE_TTL = 60 * 1000; // 1 minute TTL (in milliseconds)

  // Fetch meal data
  const fetchMealsData = async () => {
    setIsLoading(true); // Set loading to true while fetching
    try {
       const cacheName = 'AgentCache';
       const cache = await caches.open(cacheName);

       const cachedResponse = await cache.match(`${apiGlobal}/meal_data.php`);
       const currentTime = new Date().getTime(); // Current timestamp in milliseconds

       if (cachedResponse) {
        const cachedData = await cachedResponse.json();
        const { cachedAt } = cachedData;
 // If cached data is older than the TTL (1 minute), invalidate the cache and fetch new data
 if (currentTime - cachedAt < CACHE_TTL) {
  // console.log('Using cached data');
  setMealsData(cachedData.data);
  setFilteredMealsData(cachedData.data);
  setIsLoading(false);
  return; // Return early if cache is valid
} 

// console.log('Cache expired, fetching new data');
          // If cached data is expired, delete it from the cache
          await cache.delete(`${apiGlobal}/meal_data.php`);
      }

      const formData = new FormData();
      formData.append('country_id', countryId);

      const response = await fetch(`${apiGlobal}/meal_data.php`, {
        method: 'POST',
        body: formData,
      });
      const mealsResponse = await response.json();

      if (mealsResponse && Array.isArray(mealsResponse.data)) {
        // console.log('Loaded successfully');
        if (isMounted.current) {
          setMealsData(mealsResponse.data);
          setFilteredMealsData(mealsResponse.data);
// Add TTL information to the data before caching
const dataWithTTL = {
  data: mealsResponse.data,
  cachedAt: currentTime, // Store the time when the data was cached
};

// Cache the new response for future use
await cache.put(
`${apiGlobal}/meal_data.php`, 
  new Response(JSON.stringify(dataWithTTL)),
);
        }
      } else {
        console.log('No data found');
        if (isMounted.current) {
          setMealsData([]);
          setFilteredMealsData([]);
        }
      }
    } catch (error) {
      console.error('Error loading meals', error);
    } finally {
      setIsLoading(false); // Set loading to false once data is fetched
    }
  };

  useEffect(() => {
    isMounted.current = true;
    fetchMealsData();

    // Set interval to refresh data every 1 minute
    const intervalId = setInterval(fetchMealsData, 60000); // 60000ms = 1 minute

    return () => {
      isMounted.current = false;
      clearInterval(intervalId);
    };
  }, [refresh, sideBarRefresh?.agentMealRefresh]); 

  // Handler for search
  const handleSearch = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query) {
      const filteredData = mealsdata.filter(meal => meal.name.toLowerCase().includes(query.toLowerCase()));
      setFilteredMealsData(filteredData); 
    } else {
      setFilteredMealsData(mealsdata); 
    }
  };

  // Refresh handler
  const refreshHandler = () => {
    setSearchQuery('');
      setRefresh(prev => !prev);
      toast.success('Refreshing...');
  };

  const handleCancelAddMeal = () => {
    setTripDataFlag({
      ...tripDataFlag,
      addMealINBooking: false,
    });
    history.push('/agent/booking');
    toast.success('Add Meal Cancel');
  };

 // use Effect to add keyframes for the pulse animation
 useEffect(() => {
  // Add keyframes via JavaScript when component mounts
  const style = document.createElement('style');
  style.innerHTML = `
    @keyframes pulse {
      0% { transform: scale(1); opacity: 1; }
      50% { transform: scale(1.2); opacity: 0.8; }
      100% { transform: scale(1); opacity: 1; }
    }
  `;
  document.head.appendChild(style);
}, []);

  if (isLoading) {
    return (
      <div>
        <ProgressBar />
      </div>
    );
  }


  return (
    <Container>
      <Row>
        <Col md={12} />
      </Row>

      <Row>
        <div className="col-md-4 mb-4 d-flex align-items-center">
          <Form.Control
            type="text"
            placeholder="Search by Meal Name..."
            value={searchQuery}
            onChange={handleSearch}
            className="flex-grow-1"
          />
          <ButtonGroup icons dir="ltr" className="mt-2">
            <Button
              variant="outline-secondary"
              className="ms-3"
              title="Refresh"
              size="sm"
              onClick={refreshHandler}
            >
              <span className="lnr lnr-sync" />
            </Button>
          </ButtonGroup>

          <ButtonGroup icons dir="ltr" className="mt-2 mx-2">
            {tripDataFlag.addMealINBooking 
            && (
            <Button 
              variant="danger"
              title="Cancel Add Meal"
              size="sm"
              onClick={handleCancelAddMeal}
            >
              Cancel Add Meal
            </Button>
            )}
          </ButtonGroup>
          
        </div>
      </Row>

      <Row>
        <div>
          {filteredMealsData.length === 0 ? (
            <div style={{
              textAlign: 'center',
              padding: '50px',
              backgroundColor: '#f8d7da',
              borderRadius: '8px',
              marginTop: '20px',
                          color: '#721c24',
              fontSize: '16px',
                        }}
            >
              <div
                style={{
                fontSize: '48px',
                marginBottom: '20px',
                color: '#e63946',
                animation: 'pulse 1.5s infinite ease-in-out',
                display: 'inline-block',
                }}
              >
                <FaExclamationCircle style={{ fontSize: '48px', marginBottom: '20px' }} />
              </div>
              <p>No meal available</p>
            </div>
          ) : (
            currentItems.map(meal => (
              <div key={meal.id}>
                <MealCard
                  id={meal.id}
                  mealname={meal.name}
                  restaurantname={meal.restaurant_name}
                  description={meal.description}
                  type={meal.meal_type}
                  capacity={meal.capacity}
                  price={meal.price}
                  convertedprice={meal.converted_amt}
                  finalprice={meal.final_price}
                  format={meal.meal_format}
                  image={meal.photo}
                  isVeg={meal.veg_non_veg}
                  mealOffereds={meal.meal_offered}
                  cuisine={meal.cuisines}
                  locations={meal.locations}
                />
              </div>
            ))
          )}
        </div>
      </Row>

      {/* Pagination Controls */}
      <div
        style={{
          bottom: '20px',
          right: '20px',
          zIndex: 999,
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Pagination>
          <Pagination.Prev
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          />
          {pageNumbers.map((number, index) => (number === '...' ? (
            <Pagination.Ellipsis key={number} />
          ) : (
            <Pagination.Item
              key={number}
              active={number === currentPage}
              onClick={() => handlePageChange(number)}
            >
              {number}
            </Pagination.Item>
          )))}
          <Pagination.Next
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          />
        </Pagination>
      </div>
    </Container>
  );
};

export default Search;

